import { NgModule } from '@angular/core'
import { ScrollingModule } from '@angular/cdk/scrolling'

import { SharedModule } from '@shared/shared.module'

import { NotificationTriggerDirective } from './notification-trigger.directive'
import { NotificationService } from './notification.service'
import { NotificationListComponent } from './notification-list/notification-list.component'
import { NotificationComponent } from './notification-list/notification/notification.component'

@NgModule({
  declarations: [NotificationComponent, NotificationListComponent, NotificationTriggerDirective],
  imports: [SharedModule, ScrollingModule],
  exports: [NotificationComponent, NotificationListComponent, NotificationTriggerDirective],
  providers: [NotificationService],
})
export class NotificationsModule {}
